// Where a call, a job or a customer came from (call-handling item 3, BL-008): the campaign the server
// credited it to, in words. The screen decides nothing: the dialled number's campaign, or what the
// office booked the job under, comes from the server.
import { CHANNEL_WORDS, type CampaignRef } from '../settings/campaigns-model.ts';

/** "Spring tune-up · Google Ads"; a campaign named for its channel says it once. */
export function campaignWord(c: CampaignRef): string {
  const channel = CHANNEL_WORDS[c.channel] ?? c.channel;
  return c.name.trim().toLowerCase() === channel.toLowerCase() ? channel : `${c.name} · ${channel}`;
}

/** The line a call came in on: "(250) 555-0100", with its tracking number's label when it has one. */
export const lineWord = (phone: string, trackingLabel: string | null | undefined) =>
  trackingLabel ? `${phone} · ${trackingLabel}` : phone;
